import animateScrollTo from 'animated-scroll-to';

export default class StartPage extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickStartBtn = this.onClickStartBtn.bind(this);
    this.onClickVideoSwapBtn = this.onClickVideoSwapBtn.bind(this);
    this.onClickScrollTo = this.onClickScrollTo.bind(this);

    // privates
    this._node = this;
    this._videos_slider = this._node.querySelector(".videos-slider");
    this._video_holder = this._node.querySelectorAll(".video-holder");
    this._start_btn = this._node.querySelectorAll(".start-btn");
    this._video_swap_btn = this._node.querySelectorAll(".video-swap-btn");
    this._scroll_to_btn = this._node.querySelectorAll(".scroll-to-btn");
    this._current_id = '';
    this._enter = false;

    // events
    this._start_btn.forEach((el) => {
      el.addEventListener('click', this.onClickStartBtn);
    });

    this._video_swap_btn.forEach((el) => {
      el.addEventListener('click', this.onClickVideoSwapBtn);
    });

    this._scroll_to_btn.forEach((el) => {
      el.addEventListener('click', this.onClickScrollTo);
    });
  }

  onClickStartBtn(e) {
    let target = e.currentTarget,
        to_id = target.getAttribute('data-to');

    this._current_id = to_id;
    this.playVideo();

    if (this._current_id === 'main') {
      this._videos_slider.classList.add('--main');
    }

    if (!this._enter) {
      this._enter = true;
      document.body.classList.add('--enter');
      document.body.classList.remove('lock-start');

      this._videos_slider.offsetHeight;
      this._videos_slider.classList.remove('no-trans');
    }
  }

  onClickVideoSwapBtn(e) {
    let target = e.currentTarget,
        to_id = target.getAttribute('data-to');

    this._current_id = to_id;

    if (this._current_id === 'main') {
      this._videos_slider.classList.add('--main');
    } else {
      this._videos_slider.classList.remove('--main');
    }

    this.playVideo();

    if (window.pageYOffset >= 0) {
      animateScrollTo(0);
    }
  }

  playVideo() {
    this._video_holder.forEach((el) => {
      let video = el.querySelector('video'),
          vid_id = el.getAttribute('data-id');

      // Stop any videos...
      video.pause();
      // video.removeAttribute('controls');
      video.currentTime = 0;

      // Hide video button and flush
      el.classList.remove('--current');
      el.offsetHeight;

      // Play current video...
      if (vid_id === this._current_id) {
        el.classList.add('--current');
        video.play();
        // video.setAttribute('controls', true);
      }
    });
  }

  onClickScrollTo(e) {
    let target = this._node.querySelector('.faq-carousel'),
        offset = window.innerWidth >= 768 ? 32 : 16;

    this._video_holder.forEach((el) => {
      let video = el.querySelector('video');
      video.pause();
    });

    if (target) {
      let destination = target.offsetTop - offset;
      if (destination !== window.pageYOffset) {
        animateScrollTo(destination);
      }
    }
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    this._start_btn.forEach((el) => {
      el.removeEventListener('click', this.onClickStartBtn);
    });

    this._video_swap_btn.forEach((el) => {
      el.removeEventListener('click', this.onClickVideoSwapBtn);
    });

    this._scroll_to_btn.forEach((el) => {
      el.removeEventListener('click', this.onClickScrollTo);
    });
  }
}
